// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GroupsService } from '../../core/services/group.service';
import { PolicyDetailsActionTypes, CompleteLoadPolicyDetailsAction, FailLoadPolicyDetailsAction } from './policy-details.actions';
import { PolicyService } from '@app/core';
import { PolicyDetailResponse } from '../../../core/models/index';

@Injectable()
export class PolicyDetailsEffects {

  @Effect()
  requestOnLoadPolicy$ = this.actions$.pipe(
    ofType(PolicyDetailsActionTypes.POLICY_DETAILS_LOADING),
    switchMap(({ payload }: any) =>
      this.policyService.get(payload).pipe(
        map((response: PolicyDetailResponse) => {
          return new CompleteLoadPolicyDetailsAction(response);
        }),
        catchError((err) =>  {
          return of(new FailLoadPolicyDetailsAction(payload));
        })
      )
    )
  );

  constructor(private actions$: Actions, private policyService: PolicyService) {}
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/policy-details/policy-details.effects.ts